import { render, staticRenderFns } from "./ShiftsFilter.vue?vue&type=template&id=4d8192ee&"
import script from "./ShiftsFilter.vue?vue&type=script&lang=js&"
export * from "./ShiftsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports